<button mat-raised-button color="primary" class="bg-color-primary mr-4" *ngIf="canCreateCargoRequest"
    (click)="createCargoRequest()">
    Crear solicitud de servicio
</button>